var map = {
	"./admin-portal.png": "0471",
	"./cross-platform.png": "d67e",
	"./different-mediums.png": "2c7a",
	"./dynamic-tariff.png": "b20a",
	"./landlord-to-tenant.png": "981f",
	"./market-premium.png": "5251",
	"./multiple-devices.png": "10a5",
	"./old-style-meter.png": "8e26",
	"./report.png": "9e23",
	"./smart-charging.png": "cbe7",
	"./upselling.png": "9c5e",
	"./visualisation.png": "659c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a54";